module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-footer.5712a059.png";